<template>
  <div>
    <headerNav title="团队代理" />
    <van-sticky>
     <van-search v-model="iptvalue" @search="onSearch" placeholder="请输入姓名按下回车" />
    </van-sticky>

    <div>
        <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky offset-top="54">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-tab v-for="(navitem,navindex) in navList" :key="navindex"> 
                 <div slot="title">
                    {{navitem.text}}
                    <van-tag type="danger" v-if="navindex==0&&resultcount">{{resultcount.subNum>99?'99+':resultcount.subNum}}</van-tag>
                    <van-tag type="danger" v-if="navindex==1&&resultcount">{{resultcount.refNum>99?'99+':resultcount.refNum}}</van-tag>
                </div>
                <van-list
                      v-model="navitem.loaded"
                      :finished="navitem.loadingType=='nomore'?true:false"
                      :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                      @load="loadData"
                  >
                    <div v-for="(item,index) in navitem.list" class="mian-list"  @click="detail(item)" :key="index">
                      <div class="mian-list-info">
                          <div class="mian-list-info-pic">
                            <img :src="$baseurl+item.memberLevelModel.imgPath">
                          </div>
                          
                          <div class="mian-list-conf">
                              <div class="mian-list-conf-ff">
                                <span>姓名:</span>
                                <span>{{item.dealerName}}</span>
                              </div>
                              <div class="mian-list-conf-ff">
                                <span>级别:</span>
                                <span>{{item.memberLevelModel.name}}</span>
                              </div>
                          </div>

                          <div class="mian-list-conf">
                              <div class="mian-list-conf-ff">
                                <span>电话:</span>
                                <span>{{item.phoneNum}}</span>
                              </div>
                              <div class="mian-list-conf-ff">
                                <span>状态:</span>
                                <span>{{item.checkTypeName}}</span>
                              </div>
                          </div>

                           <div class="mian-list-conf">
                              <div class="mian-list-conf-ff">
                                <span>锁定:</span>
                                <span>{{item.dealerStateName}}</span>
                              </div>
                          </div>

                      </div>

                      <div class="footer-info">
                            <div>注册时间:{{item.creationTime}}</div>
                      </div>
                    </div>
                </van-list>
              </van-tab>
          </van-pull-refresh>
      </van-tabs>
    </div>



    <!-- <van-tabs>
      <van-tab>
        <div slot="title">
          我的下级
          <van-tag type="danger">{{mySub.totalCount>99?'99+':mySub.totalCount}}</van-tag>
        </div>
        <div style="height:600px;overflow-y:scroll;">
          <van-list
            v-model="mySub.loading"
            :finished="mySub.finished"
            finished-text="没有更多了"
            @load="getDataMysub"
          >
            <van-cell
              v-for="item in mySub.list"
              :key="item.id"
              :title="'姓名:'+item.dealerName"
              :value="'级别:'+item.memberLevelModel.name"
            >
              <div slot="label">
                <p>{{'手机号码:'+item.phoneNum}}</p>
                <p>{{'审核状态:'+item.checkTypeName}}</p>
                <p>{{'账户状态:'+item.dealerStateName}}</p>
              </div>
            </van-cell>
          </van-list>
        </div>
      </van-tab>
      <van-tab>
        <div slot="title">
          我的推荐
          <van-tag type="danger">{{myRef.totalCount>99?'99+':myRef.totalCount}}</van-tag>
        </div>
        <div style="height:600px;overflow-y:scroll;">
          <van-list
            v-model="myRef.loading"
            :finished="myRef.finished"
            finished-text="没有更多了"
            @load="getDataMyRef"
          >
            <van-cell
              v-for="item in myRef.list"
              :key="item.id"
              :title="'姓名:'+item.dealerName"
              :value="'级别:'+item.memberLevelModel.name"
            >
              <div slot="label">
                <p>{{'手机号码:'+item.phoneNum}}</p>
                <p>{{'审核状态:'+item.checkTypeName}}</p>
                <p>{{'账户状态:'+item.dealerStateName}}</p>
              </div>
            </van-cell>
          </van-list>
        </div>
      </van-tab>
    </van-tabs> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
     tabCurrentIndex:0,
     refreshing: false,
     navList: [{
          state: 0,
          text: '我的下级',
          loadingType: 'more',
          loaded:false,
          totalCount: 0,
          requrl:'/api/services/app/PhoneUser/QueryMySubDealer',
          getparams: {
              "sorting": "",
              "maxResultCount": 10,
              "skipCount": 0
          },
          list: []
          },
          {
            state: 1,
            text: '我的推荐',
            loadingType: 'more',
            totalCount: 0,
            loaded:false,
             requrl:'/api/services/app/PhoneUser/QueryMyRefDealer',
            getparams: {
                "sorting": "",
                "maxResultCount": 10,
                "skipCount": 0
            },
            list: []
          }
      ],
      iptvalue:'',
      resultcount:undefined
    };
  },
  created(){
      this.querycountinfo();
  },
  methods: {
    onSearch(val){
      //将数组重置 并重新执行查询
      this.iptvalue=val;
      this.navList.forEach(x=>{
          x.loadingType="refresh";
      });
      this.loadData();
    },
    querycountinfo()
    {
        this.ajax.post('/api/services/app/PhoneUser/QueryRefAndSubNum').then(x=>
        {
            this.resultcount=x.result;
        })
    },
    tabchange()
    {
        this.loadData('tabChange');
    },
    onRefresh()
    {
        this.loadData('refresh');
    },
    loadData(source) {
                 
				 let index = this.tabCurrentIndex;
				let navItem = this.navList[index];
				// let state = navItem.state;
                
				if (source === 'tabChange' && navItem.loaded === true) {
					//tab切换只有第一次需要加载数据
					return;
				}
				if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
          //防止重复加载
          if(source!="refresh")
          {
            	return;
          }
				}
				if (source === 'refresh') {
					this.navList[index].list = [];
          this.navList[index].getparams.skipCount = 0;
          this.navList[index].getparams.dealerName=this.iptvalue;
				}
        if(navItem.loadingType=='refresh')
        {
	        this.navList[index].list = [];
          this.navList[index].getparams.skipCount = 0;
          this.navList[index].getparams.dealerName=this.iptvalue;
        }

				navItem.loadingType = 'loading';
        var params = navItem.getparams;
        var url=navItem.requrl;
				//加载数据
				this.ajax.post(url, params).then(x => {
          this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
          let totalcount = x.result.totalCount;
          this.navList[index].list = this.navList[index].list.concat(x.result.items);
          this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' :'nomore';
          this.navList[index].totalCount= totalcount;
        }).finally(()=>
        {
          this.navList[index].loaded=false;
          this.refreshing=false;
        });
    },
    getDataMysub() {
      this.ajax
        .post(
          "/api/services/app/PhoneUser/QueryMySubDealer",
          this.mySub.pageParams
        )
        .then((x) => {
          const items = x.result.items;
          this.mySub.list.push(...x.result.items);
          this.mySub.pageParams.skipCount += this.mySub.pageParams.maxResultCount;
          this.mySub.totalCount = x.result.totalCount;
        })
        .finally(() => {
          this.mySub.loading = false;
          if (this.mySub.pageParams.skipCount >= this.mySub.totalCount) {
            this.mySub.finished = true;
          }
        });
    },
    getDataMyRef() {
      this.ajax
        .post(
          "/api/services/app/PhoneUser/QueryMyRefDealer",
          this.myRef.pageParams
        )
        .then((x) => {
          const items = x.result.items;
          this.myRef.list.push(...x.result.items);
          this.myRef.pageParams.skipCount += this.myRef.pageParams.maxResultCount;
          this.myRef.totalCount = x.result.totalCount;
        })
        .finally(() => {
          this.myRef.loading = false;
          if (this.myRef.pageParams.skipCount >= this.myRef.totalCount) {
            this.myRef.finished = true;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.mian-list{
  background-color: #fff;
  margin-top: 10px;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  padding-bottom: 20px;
  word-break: break-all;
}
.mian-list-info{
  position: relative;
  margin-bottom: 15px;
}
.mian-list-info-pic{
    position: absolute;
    left: 0;
    width: 60px;
    height: 60px;
    top: 50%;
    transform: translate(0, -50%);
    border-radius: 50%;
    padding:4px;
}
.mian-list-info-pic img
{
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border-radius: 50%;
}
.mian-list-conf{
    padding-left: 70px;
    font-size: 14px;
    line-height: 25px;
}
.mian-list-conf-ff{
    display: inline-block;
    width: 120px;
    vertical-align: top;
    margin-left: 10px;
}
.mian-list-conf-ff span:last-child{
  color:#929292;
}
.footer-info{
  font-size: 14px;
  border-top: 1px solid #e0e0e0;
  padding-top: 10px;
  color:#929292;
  text-align: right;
}

</style>